import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import IntegrationsSettings from './settings/IntegrationsSettings';
import RoutingSettings from './settings/RoutingSettings';
import IncidentContactsSettings from './settings/IncidentContactsSettings';
import AiSettings from './settings/AiSettings';
import AppearanceSettings from './settings/AppearanceSettings';
import SecuritySettings from './settings/SecuritySettings';

// Settings: a section list on the left, one section at a time (?tab=).
const GROUPS = [
  ['YOU', [['appearance', 'Appearance']]],
  ['ORGANISATION', [
    ['integrations', 'Integrations'],
    ['routing', 'Alert routing'],
    ['contacts', 'Incident contacts'],
    ['ai', 'AI & automation'],
    ['security', 'Security'],
  ]],
];
// Old links: the Notifications tab became Alert routing.
const ALIASES = { notifications: 'routing' };
const ALL = GROUPS.flatMap(([, items]) => items.map(([id]) => id));

export default function Settings() {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('tab') || 'integrations';
  const tab = ALIASES[raw] || (ALL.includes(raw) ? raw : 'integrations');
  const go = (id) => setSearchParams({ tab: id });

  return (
    <div className="p-6 lg:p-8 flex flex-col gap-5" style={{ color: 'var(--ink-text)' }}>
      <div className="flex flex-col gap-2">
        <span className="font-mono text-[11.5px] tracking-[0.14em]" style={{ color: 'var(--ink-link)' }}>MANAGEMENT</span>
        <h1 className="m-0 font-heading text-[30px] font-semibold tracking-[-0.01em] leading-tight">Settings</h1>
        <p className="m-0 text-sm" style={{ color: 'var(--ink-muted)' }}>How DragonEye connects to other tools, where alerts go, and what the AI may do. Changes need an administrator.</p>
      </div>

      <div className="flex flex-wrap items-start gap-6">
        <nav aria-label="Settings sections" className="flex-[1_1_220px] max-w-[260px] flex flex-col gap-0.5">
          {GROUPS.map(([k, items]) => (
            <React.Fragment key={k}>
              <span className="font-mono text-[10px] tracking-[0.12em] px-2.5 pt-3 pb-1.5" style={{ color: 'var(--ink-faint)' }}>{k}</span>
              {items.map(([id, t]) => {
                const on = tab === id;
                return (
                  <button key={id} type="button" onClick={() => go(id)} aria-current={on ? 'page' : undefined} className="relative min-h-[40px] flex items-center px-2.5 rounded-lg text-left text-[13.5px]" style={{ background: on ? 'var(--surf-raised)' : 'transparent', color: on ? 'var(--ink-text)' : 'var(--ink-muted)', fontWeight: on ? 600 : 400 }}>
                    {on && <span aria-hidden="true" className="absolute left-0 top-2.5 w-0.5 h-5 rounded-sm" style={{ background: 'var(--accent)' }} />}{t}
                  </button>
                );
              })}
            </React.Fragment>
          ))}
          <Link to="/org/members" className="mt-2.5 min-h-[40px] flex items-center px-2.5 text-[13px]" style={{ color: 'var(--ink-link)' }}>Members &amp; roles →</Link>
        </nav>

        <div className="flex-[999_1_560px] min-w-0">
          {tab === 'integrations' && <IntegrationsSettings onGo={go} />}
          {tab === 'routing' && <RoutingSettings />}
          {tab === 'contacts' && <IncidentContactsSettings />}
          {tab === 'ai' && <AiSettings onGo={go} />}
          {tab === 'appearance' && <AppearanceSettings />}
          {tab === 'security' && <SecuritySettings />}
        </div>
      </div>
    </div>
  );
}
